import { Gap } from 'component/Space'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { BodySelect } from 'page/ProfileScreen/BasicSelfiesPanel/body/BodySelect'
import { ContinueButton } from 'page/ProfileScreen/BasicSelfiesPanel/ContinueButton'
import { ShapeSelect } from 'page/ProfileScreen/BasicSelfiesPanel/shape/ShapeSelect'
import { controller } from 'store/controller'
import { opt } from 'store/opt'
import { store } from 'store/store'

export const ThirdStep = observer(() => {
  const basic = store.profile.basic
  const canContinue = opt.sizes ? !!basic.shape && !!basic.body : !!basic.body

  const onContinue = useLatestCallback(async () => {
    if (opt.sizes) basic.step = 'fourth'
    else controller.generateBasic()
  })

  return (
    <Vertical>
      <Vertical>
        <Typo size={24} tertiary upper center>
          {i18n('StepCount', { count: 3 })}
        </Typo>
        <Typo size={32} medium upper center>
          {i18n('DescribeYourAppearance')}
        </Typo>
      </Vertical>
      <Gap height={80} />
      {opt.sizes && <Vertical gap={24}>
        <Typo size={32} medium center>
          {i18n('BodyType')}
        </Typo>
        <ShapeSelect />
      </Vertical>}
      {opt.sizes && <Gap height={120} />}
      <Vertical gap={24}>
        <Typo size={32} medium center>
          {i18n('BodySize')}
        </Typo>
        <BodySelect />
      </Vertical>
      <Gap height={120} />
      <ContinueButton disabled={!canContinue} action={onContinue} />
    </Vertical>
  )
})
